import { eventBus } from 'EventBus/';
import { pushEvent } from '../../utils/datalayer';

const NAVIGATION = '.header-nav';
const NAV_PANELS = '.header-nav__category-panel';

const BURGER_BTN = 'nav-burger';
const MY_ACCOUNT_BTN = 'nav-my-account';
const SEARCH_BTN = 'nav-search';

const NAV_BUTTONS = 'button.header-nav__nav-button';
const PANEL_CATEGORY = '--category';
const PANEL_SUBCATEGORY = '--sub-category';
const SEARCH_PANEL = '.header-search';
const SEARCH_INPUT = '#nav-search-query';

const ARIA_EXPANDED = 'aria-expanded';
const ARIA_HIDDEN = 'aria-hidden';

const OPEN_NAV = 'headernav::openNav';
const TOGGLE_PANEL = 'headernav::togglePanel';
const TOGGLE_SEARCH = 'headernav::toggleSearch';

const SEARCH_ICON_HREF = '#search';
const CLOSE_ICON_HREF = '#close';

const OPEN = '--open';
const CLOSING = '--closing';
const ACTIVE = '--active';
const BODY = 'body';

const DEFAULT_SEARCH_OPEN_LABEL = 'Search';
const DEFAULT_SEARCH_CLOSED_LABEL = 'Close (X)';

let tabletMediaQuery = '(min-width: 64rem)'; // 1024px
var lastChild;
let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

window.addEventListener(
  'resize',
  function (event) {
    tabletMediaQuery = '(min-width: 64rem)';
    scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  },true);

const emitEvent = (type, index = null) => {
  eventBus.$emit(type, index);
};

if(window.matchMedia(tabletMediaQuery).matches) {
  if(document.getElementById("sliderprev")) {
    document.getElementById("sliderprev").style.display = "none";
  }
  if(document.getElementById("slidernext")) {
    document.getElementById("slidernext").style.display = "none";
  }
  if(document.getElementById("menuslider")) {
    document.getElementById("menuslider").removeAttribute("v-slider",undefined);
  }  
}else{
  if(document.getElementById("menuslider")) { 
    document.getElementById("menuslider").setAttribute("v-slider",undefined);
  }
}
const openMenu = (fromBurger = false, el) => {
  let openSubCategory = null;
  // Close Search Menu if it's open
  if (document.querySelector(SEARCH_PANEL)?.classList.contains(OPEN)) {
    toggleSearchClosed();
  }
  if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
    if(!window.matchMedia(tabletMediaQuery).matches) {
      return;
    }
  }
  document.querySelector(BODY)?.classList.add('navOpen');
  if (fromBurger) {
    document.querySelector(NAVIGATION)?.classList.add(OPEN, ACTIVE);
    if (document.body.classList.contains('isUsingKeyboard')) {
      document.querySelector(NAVIGATION)?.querySelector('BUTTON')?.focus();
    }
  } else {
    document.querySelector(NAVIGATION)?.classList.add(OPEN);
    document.querySelector(".header")?.classList.add(OPEN);
    if (el?.classList.contains(PANEL_CATEGORY)) {
      let navItem = el.closest('LI');
      let firstSubCat = navItem?.querySelector(`BUTTON.${PANEL_SUBCATEGORY}`);

      openSubCategory = firstSubCat;
    }
  }
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, true);
  document.querySelector('main')?.setAttribute(ARIA_HIDDEN, true);
  document.querySelector('footer')?.setAttribute(ARIA_HIDDEN, true);
  emitEvent(OPEN_NAV, { status: true, fromBurger });

  return openSubCategory;
};

const deactivatePanels = (subcatOnly = false) => {
  const deactivateElement = (el) => {
    if (el.tagName === 'BUTTON') {
      el?.setAttribute(ARIA_EXPANDED, false);
    } else {
      el?.classList.remove(ACTIVE);
    }
  };

  if (!subcatOnly) {
    const catEls = document.querySelectorAll(`.${PANEL_CATEGORY}`);
    catEls.forEach(deactivateElement);
  }

  const subCatEls = document.querySelectorAll(`.${PANEL_SUBCATEGORY}`);
  subCatEls.forEach(deactivateElement);
};

const closeMenu = (e) => {
  e.stopPropagation();
  // Menu is already open
  document.querySelector(BODY)?.classList.remove('navOpen');
  // Mobile gets a timeout for it to slide shut before deactivating the content
  const closeTimeout = window.matchMedia(tabletMediaQuery).matches ? 0 : 300;
  document.querySelector(NAVIGATION)?.classList.remove(OPEN);
  document.querySelector(".header")?.classList.remove(OPEN);
  document.querySelector(NAVIGATION)?.classList.add(CLOSING);
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, false);
  let headerEle = document.querySelector('#header');
  if(headerEle && window.matchMedia(tabletMediaQuery).matches) {
    headerEle.style.paddingRight = 0 + "px";
  }
  if(closeTimeout == 300) {
    setTimeout(() => {
      closemenuwithsettimeout();
    }, closeTimeout);
  }else{
    closemenuwithsettimeout();
  }
};

const closemenuwithsettimeout = ()=> {
    document.querySelector(NAVIGATION)?.classList.remove(ACTIVE);
    document.querySelector(NAVIGATION)?.classList.remove(CLOSING);
    // Remove Open/Current Modifiers
    const panels = document.querySelectorAll(NAV_PANELS);
    panels.forEach((p) => p?.classList.remove(ACTIVE));

    const navButtons = document.querySelectorAll(NAV_BUTTONS);
    navButtons.forEach((b) => b?.setAttribute(ARIA_EXPANDED, false));

    document.querySelector('main')?.removeAttribute(ARIA_HIDDEN);
    document.querySelector('footer')?.removeAttribute(ARIA_HIDDEN);
    emitEvent(OPEN_NAV, { status: false, fromBurger: false });
}

const togglePanelClosed = (trigger, target,e) => {
  e.stopPropagation();
  if (target && document.querySelector(`#${target}.${ACTIVE}`)) {
    document.querySelector(`#${target}`)?.classList.remove(ACTIVE);
    trigger?.setAttribute(ARIA_EXPANDED, false);
    emitEvent(TOGGLE_PANEL, target);
  }
};

const getLastChildOfNavMenu = (event) => {
  let listOfsubcategory = document.querySelectorAll(`.${PANEL_SUBCATEGORY} ul`);
  for (let i = 0; i < listOfsubcategory.length; i++) {
    for (let j = 0; j < listOfsubcategory[i].children.length; j++) {
      listOfsubcategory[i].children[j].addEventListener('keydown', (event) => {
        if (event.code == 'Escape') {
          closeMenu(event);
        }
      });
    }
  }
  if (event.keyCode === 27) {
    closeMenu(event); 
  }
  let nextsibling = document.getElementById(
    event.target.id
  )?.nextElementSibling;
  if (nextsibling != null) {
    let nextElementChildrens = document.getElementById(event.target.id)
      ?.nextElementSibling.children;
    if (nextElementChildrens.length > 0) {
      let innerClass = nextElementChildrens[0];
      let details = innerClass?.children[3]?.children;
      for (let i = 0; i < details?.length; i++) {
        lastChild = details[details.length - 1].children[0].innerText;
      }
    }
  }
};

const closeMenuOnLastChild = (event) => {
  if (lastChild === event.target.innerText && event.key == 'Tab') {
    closeMenu(event);
  }
};

const togglePanelOpen = (trigger, target) => {
  trigger.focus();

  if (!target) deactivatePanels(true);

  if (target && !document.querySelector(`#${target}.${ACTIVE}`)) {
    let firstSubCat = openMenu(false, trigger);
    // Deactivate sibling panels
    if (trigger?.classList.contains(PANEL_CATEGORY)) {
      deactivatePanels(false);
    }
    if (trigger?.classList.contains(PANEL_SUBCATEGORY)) {
      deactivatePanels(true);
    }

    // Opens first sub category if applicable
    if (firstSubCat) firstSubCat.click();
    document.querySelector(`#${target}`)?.classList.add(ACTIVE);
    let headerEle = document.querySelector('#header');
    if(headerEle && window.matchMedia(tabletMediaQuery).matches) {
      headerEle.style.paddingRight = scrollbarWidth + "px";
    } 
    if(trigger) {
      let panelbutton = trigger.querySelector('button');
      if(panelbutton) {
        panelbutton?.setAttribute(ARIA_EXPANDED, true);
      }else {
        trigger?.setAttribute(ARIA_EXPANDED, true);
      }
    }
    if(window.matchMedia(tabletMediaQuery).matches){
      let hovertarget = document.querySelector(`#${target}`);
      let subcategoryButton = hovertarget.querySelectorAll(".header-nav__nav-button.--sub-category");
      let subcategoryPanel = hovertarget.querySelector(".header-nav__category-panel.--sub-category")
      subcategoryButton.forEach((subitem, i) => {
        subitem.setAttribute(ARIA_EXPANDED, i === 0);
      });
      if(subcategoryPanel != null) {
        subcategoryPanel.classList.add(ACTIVE);
      }
      const fixedContainer = document.querySelector('.header-nav__category-panel.--category.--active');
      fixedContainer.style.bottom = "unset";
      const viewportHeight = window.innerHeight;
      let overallheight = fixedContainer.getBoundingClientRect().height;
      if (overallheight >= viewportHeight) {
        // If content exceeds the viewport, set bottom to 0
        fixedContainer.style.bottom = '0';
      } 
      else {
        // If content does not exceed the viewport, reset bottom
        fixedContainer.style.bottom = 'unset';
        fixedContainer.style.overflowY = 'hidden';
        let subcontainer = document.getElementsByClassName("header-nav__category-panel --sub-category --active");
        if(subcontainer.length > 0) {
          let subcontainerheight = subcontainer[0].offsetHeight;
          let fixedContainerHeight = fixedContainer.querySelector(".header-nav__nav-list").offsetHeight
          if(subcontainerheight > fixedContainerHeight) {
            let remainingHeight = (overallheight - subcontainerheight);
            let fixedHeight = overallheight + remainingHeight;
            fixedContainer.firstElementChild.style.height = fixedHeight + "px";
          }
        }
      }
    }
    emitEvent(TOGGLE_PANEL, target);
  }
};

const toggleSearchClosed = () => {
  const searchButton = document.getElementById(SEARCH_BTN);
  searchButton?.setAttribute(ARIA_EXPANDED, false);
  searchButton
    ?.querySelector('svg>use')
    .setAttribute('xlink:href', SEARCH_ICON_HREF);

  const openLabel =
    searchButton.getAttribute('data-open-label') || DEFAULT_SEARCH_OPEN_LABEL;
  searchButton?.querySelector('svg')?.setAttribute('aria-label', openLabel);

  document.getElementById(MY_ACCOUNT_BTN)?.removeAttribute('tabindex');
  document.querySelector(SEARCH_PANEL)?.classList.remove(OPEN);
  document.querySelector(BODY)?.classList.remove('--openSearch');
  emitEvent(TOGGLE_SEARCH, { status: false });
};
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSearchClosed();
  }
});
document.addEventListener('focusin', (event) => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchButton = document.getElementById(SEARCH_BTN);
  if (
    searchPanel &&
    !searchPanel.contains(event.target) &&
    searchButton &&
    !searchButton.contains(event.target)
  ) {
    toggleSearchClosed();
  }
});
const toggleSearchPanel = (e) => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchInput = document.querySelector(SEARCH_INPUT);
  if (searchInput) searchInput.value = '';
  if (!searchPanel?.classList.contains(OPEN)) {
    // Check if nav is open, and close it if needed
    if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
      closeMenu(e);
    }
    // Open Search Panel
    const searchButton = document.getElementById(SEARCH_BTN);
    searchButton?.setAttribute(ARIA_EXPANDED, true);
    const closeLabel =
      searchButton.getAttribute('data-close-label') ||
      DEFAULT_SEARCH_CLOSED_LABEL;
    searchButton?.querySelector('svg')?.setAttribute('aria-label', closeLabel);
    searchButton
      ?.querySelector('svg>use')
      .setAttribute('xlink:href', CLOSE_ICON_HREF);

    document.getElementById(MY_ACCOUNT_BTN)?.setAttribute('tabindex', '-1');

    pushEvent({
      event: 'uaevent',
      event_name: 'search_icon_click',
      ecommerce: 'undefined',
      click_area: 'header',
    });

    searchPanel?.classList.add(OPEN);
    document.querySelector(BODY)?.classList.add('--openSearch');
    searchInput.focus();
    emitEvent(TOGGLE_SEARCH, { status: true });
  } else {
    toggleSearchClosed();
  }
};

const headerNav = {
  name: 'headernav',
  inserted: (el, binding) => {
    const { arg, value } = binding;

    switch (arg) {
      case 'burger':
        el.addEventListener('click', () => {
          openMenu(true);
        });
        break;

      case 'paneltoggle':
        el.addEventListener('click', () => {
          togglePanelOpen(el, value ? value.id : undefined);
        });
        el.addEventListener('mouseenter', () => {
          if (window.matchMedia(tabletMediaQuery).matches) {
            togglePanelOpen(el, value ? value.id : undefined);
          }
        });
        if (window.matchMedia(tabletMediaQuery).matches) {
          el.addEventListener('mouseleave', (e) => {
            closeMenu(e);
          });
        }
        el.addEventListener('keydown', (event) => {
          closeMenuOnLastChild(event);
        });
        el.addEventListener('keyup', (event) => {
          getLastChildOfNavMenu(event);
        });
        break;

      case 'level2paneltoggle':
        el.addEventListener('click', () => {
          togglePanelOpen(el, value ? value.id : undefined);
        });
        break;

      case 'backreturn':
        el.addEventListener('click', (e) => {
          togglePanelClosed(el, value ? value.id : undefined,e);
        });
        break;

      case 'menuclose':
        el.addEventListener('click', (e) => {
          closeMenu(e);
        });
        el.addEventListener('mouseenter', (e) => {
          if (window.matchMedia(tabletMediaQuery).matches && value) {
            closeMenu(e);
          }
        });

        break;

      case 'menuleave':
        el.addEventListener('mouseenter', (e) => {
          closeMenu(e);
        });
        break;

      case 'searchtoggle':
        el.addEventListener('click', () => {
          toggleSearchPanel();
        });
        break;

      case 'searchclose':
        el.addEventListener('click', () => {
          toggleSearchClosed();
        });
        break;

      default:
        break;
    }
  },
};

export {
  headerNav,
  emitEvent,
  openMenu,
  deactivatePanels,
  closeMenu,
  togglePanelClosed,
  togglePanelOpen,
  toggleSearchClosed,
  toggleSearchPanel,
  closeMenuOnLastChild,
  getLastChildOfNavMenu,
};